<template>
    <app-data-table
        :fields="fields"
        :items="accuses.data"
        :current-page="accuses.current_page"
        :last-page="accuses.last_page"
        :from="accuses.from"
        :to="accuses.to"
        :total="accuses.total"
        :per-page="accuses.per_page"
        :on-change-page="onChangePage"
    >
        <template slot="indicator" slot-scope="{ item }">
            <i class="fa fa-3 fa-ban" v-if="!item.isAudience"></i>
            <i class="fa fa-3 fa-check" v-else-if="!!item.created_at"></i>
            <i class="fa fa-3 fa-times" v-else></i>
        </template>

        <template slot="created_at" slot-scope="{ item }">
            {{ item.created_at | datetime }}
        </template>
    </app-data-table>
</template>
<script>
export default {
    props: {
        accuses: {
            type: [Object, null],
            default: () => []
        }
    },
    data: () => ({
        fields: [
            {
                key: 'name',
                label: 'Usuario'
            },            
            {
                key: 'indicator',
                label: 'Confirmado'
            },
            {
                key: 'created_at',
                label: 'Fecha de confirmación'
            },
        ]
    }),
    methods: {
        onChangePage(page) {
            this.$emit('on-change-page', page);
        }
    }
}
</script>